import { useEffect, useState } from "react";
import { useCart } from "@/contexts/cart/CartContext";
import { GET_CART } from "@/services/cart";

const useFreshCart = () => {
  const { cart, dispatch } = useCart();
  const [fresh, setFresh] = useState(false);
  const itemsQty = cart?.itemsQty;

  useEffect(() => {
    let active = true;
    setFresh(false);
    (async () => {
      const res = await GET_CART();
      if (!active) return;
      if (res?.data?.data) {
        dispatch({ type: "GET_CART", payload: res.data.data });
      }
      setFresh(true);
    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsQty]);

  return { cart, fresh };
};

export default useFreshCart;
